export default "__VITE_ASSET__1d737991__"